import {IdCheckEvent} from './IdCheckEvent'
import {Props} from '@peachy/utility-kit-pure'

export class IdCheckFlagged extends IdCheckEvent {

    constructor(from: Props<IdCheckFlagged>) {
        super(from)
        this.status = 'FLAGGED'
        this.type = this.constructor.name
    }
}


